import { defaultRoutePath } from './paths.js';

export interface UnknownRouteProps {
  visiblePath: string;
  onNavigate: (path: string) => void;
}

export function UnknownRoute({ visiblePath, onNavigate }: UnknownRouteProps) {
  return (
    <>
      <p className="text-sm font-medium uppercase tracking-wide text-primary">Página não encontrada</p>
      <h1 className="mt-2 text-3xl font-semibold">Esta página não existe.</h1>
      <p className="mt-3 opacity-70">Volte para o início e continue de onde você parou.</p>
      <div className="mt-6">
        <button className="btn btn-primary" type="button" onClick={() => onNavigate(defaultRoutePath)}>
          Ir para boas-vindas
        </button>
      </div>
    </>
  );
}
